import axios from "../../api/apiClient";
import { token, domain } from "../../components/Security";

const API_BASE = `${domain}/api/Employee`;

const headers = {
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
};

export const employeeService = {
  /**
   * Fetch employees based on dynamic V2 filters
   */
  fetchFiltered: async (payload) => {
    const response = await axios.post(`${API_BASE}/single-data/filters/V2`, payload, { headers });
    return response.data;
  },

  /**
   * Bulk Approve employees
   */
  bulkApprove: async (data) => {
    const response = await axios.put(`${API_BASE}/update-status/bulk`, data, { headers });
    return response.data;
  }
};